import _PromiseCache from './promise-cache';
function init(window) {
  if (!window.umbrella) {
    window.umbrella = {};
    [require('./cache'), require('./environment'), require('./fetch'), require('./auth'), require('./content'), require('./branding'), require('./event-proxy'), require('./module-federation')].forEach(function (m) {
      m.default(window.umbrella);
    });
  }
  return window.umbrella;
}
var umbrella = init(window || global);
export default umbrella;
export var isLocalhost = umbrella.isLocalhost;
export var getEnvironment = umbrella.getEnvironment;
export var getDomain = umbrella.getDomain;
export var getURL = umbrella.getURL;
export var fetch = umbrella.fetch;
export var getAuth = umbrella.getAuth;
export var loadBundle = umbrella.loadBundle;
export var getStringsWithAttributes = umbrella.getStringsWithAttributes;
export var getLocale = umbrella.getLocale;
export var setLocale = umbrella.setLocale;
export var getStyles = umbrella.getStyles;
export var sendEvent = umbrella.sendEvent;
export var loadModule = umbrella.loadModule;
export var cache = umbrella.cache;
export var PromiseCache = _PromiseCache;
//# sourceMappingURL=index.js.map